export default {
  details: '/gateway/capp/ActivityForAppRpcService/getPartnerActivityScoreRecord'
}
